import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  MailIcon,
  DocumentReportIcon,
  ChartBarIcon,
  CogIcon,
  LogoutIcon,
  TemplateIcon,
  UsersIcon,
  UserGroupIcon
} from '@heroicons/react/outline';

const Sidebar = () => {
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    window.location.href = '/admin/login';
  };

  // Navigation items - REMOVED Candidates
  const navigation = [
    { name: 'Dashboard', href: '/admin', icon: HomeIcon },
    { name: 'Assessments', href: '/admin/assessments', icon: TemplateIcon },
    // { name: 'Candidates', href: '/admin/candidates', icon: UsersIcon }, ← REMOVED
    { name: 'Bulk Invite', href: '/admin/invite', icon: MailIcon },
    // { name: 'Reports', href: '/admin/reports', icon: DocumentReportIcon },
    { name: 'Analytics', href: '/admin/analytics', icon: ChartBarIcon },
    { name: 'Settings', href: '/admin/settings', icon: CogIcon },
  ];

  return (
    <div className="fixed inset-y-0 left-0 w-64 bg-[#063b56]">
      <div className="flex flex-col h-full">
        {/* Logo */}
        <div className="flex items-center justify-center h-16 px-4 bg-[#063b56] border-b border-[#0a4a6a]">
          <h1 className="text-white font-bold text-xl">
            <span className="font-light">Psych</span>
            <span className="font-bold">Catalyst</span>
          </h1>
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
          {navigation.map((item) => {
            const isActive = location.pathname === item.href;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`
                  group flex items-center px-2 py-2 text-sm font-medium rounded-md 
                  transition-all duration-200
                  ${isActive
                    ? 'bg-[#ff9f2f] text-white shadow-lg'
                    : 'text-gray-300 hover:bg-[#0a4a6a] hover:text-white'
                  }
                `}
              >
                <item.icon
                  className={`
                    mr-3 h-5 w-5
                    ${isActive ? 'text-white' : 'text-gray-400 group-hover:text-white'}
                  `}
                />
                {item.name}
                {isActive && (
                  <span className="ml-auto w-1.5 h-8 bg-white rounded-full"></span>
                )}
              </Link>
            );
          })}
        </nav>

        {/* Logout Button */}
        <div className="p-4 border-t border-[#0a4a6a]">
          <button
            onClick={handleLogout}
            className="flex items-center px-2 py-2 text-sm font-medium text-gray-300 rounded-md hover:bg-[#0a4a6a] hover:text-white w-full transition-all duration-200"
          >
            <LogoutIcon className="mr-3 h-5 w-5 text-gray-400" />
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;